import { render, staticRenderFns } from "./AppInput.vue?vue&type=template&id=54acbd56"
import script from "./AppInput.vue?vue&type=script&lang=ts"
export * from "./AppInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports